import React from "react";
import HeroSection from "./HeroSection";
import ServicesSection from "./ServicesSection";
import HeritageSection from "./HeritageSection";
import TestimonialsSection from "./TestimonialsSection";
import CTASection from "./CTASection";

export default function HomePage() {
  return (
    <div className="home-page">
      <HeroSection />
      <HeritageSection />
      <ServicesSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
}
